export const setCookie = (name, value) => {
  localStorage.setItem(name, value);
};

export const getCookie = (name) => {
  return localStorage.getItem(name);
};

export const unsetCookie = (name) => {
  localStorage.removeItem(name);
};
